const baseUrl = import.meta.env.BUILD_API_BASE_URL;

export async function subscribeToPush() {
  const registration =
    await navigator.serviceWorker.register("/service-worker.js");
  console.debug("Service Worker registered");

  const token = localStorage.getItem("access_token");
  if (!token) {
    console.warn("No access token, skipping push setup");
    return;
  }

  const response = await fetch(`${baseUrl}/cng/v1/pushes/key`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  const vapidKey = data.key;

  if (!vapidKey) {
    throw new Error("VAPID key is missing in the response");
  }

  if (Notification.permission !== "granted") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return;
    }
  }

  let subscription: PushSubscription;
  try {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
  } catch (err) {
    console.error("Push subscription failed:", err);
    return;
  }

  await fetch(`${baseUrl}/cng/v1/pushes/subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      keys: subscription.toJSON().keys,
    }),
  });

  console.debug("Push subscription sent to backend");
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
